import LandingPage from "pages/LandingPage";
import React from "react";

const LandingRoute = () => <LandingPage />;

export default LandingRoute;
